import gql from 'graphql-tag';

export const FAKE_SIGNUP = gql`
  mutation {
    createFakeUser {
        token
    }
  }
`;
